import { detectSchoolSubdomainFromLocation } from '../utils/authOrigin';

/**
 * Per-district Free & Reduced Price Meals information sheets.
 * Keyed by district subdomain slug. The files live in frontend/public/forms/
 * and ship with the frontend build (served at the site root, no auth — these
 * are public informational documents, not student data).
 *
 * NOTE: intentionally a small static map for the current single-district rollout.
 * When a second district onboards, move this to per-district DB config so each
 * district's document is managed in the admin UI instead of in code. Until a
 * slug is added here, that district simply shows no link (rather than the wrong
 * district's document).
 */
const FR_INFO_DOCS = {
  vanburenr1: '/forms/vbsd-free-reduced-information.pdf',
};

/**
 * URL of the current district's Free & Reduced info sheet, or null if none is
 * configured for this district. Resolves the district from the subdomain slug.
 */
export function getFrInfoDocUrl() {
  const params = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search)
    : null;
  // On a real district subdomain the slug comes from the hostname; on
  // localhost/staging it can be supplied with ?subdomain=<slug> (the same
  // override the rest of the app honors), which also makes this previewable.
  const slug = detectSchoolSubdomainFromLocation(params);
  return (slug && FR_INFO_DOCS[slug]) || null;
}
